import { useEffect, useState } from 'react';
import { media } from 'zf-web-infra';
import { getHeicFallback } from './processUrl';
import type { ImageItem, UseInitImageSizeResult } from './types';

/**
 * 设置图片的宽高
 * @param source
 * @returns
 */
export function useNormalize(
  source: ImageItem | ImageItem[],
  baseName?: string,
  internal?: boolean
): UseInitImageSizeResult {
  const [images, setImages] = useState<ImageItem[]>([]);

  useEffect(() => {
    let cancelled = false;
    const normalizeImages = async (): Promise<void> => {
      const result: ImageItem[] = [];
      for (const image of Array.isArray(source) ? source : [source]) {
        result.push(await normalize(image, baseName, internal));
      }
      if (!cancelled) {
        setImages(result);
      }
    };
    void normalizeImages();
    return (): void => {
      cancelled = true;
    };
  }, [source, baseName, internal]);

  return { images };
}

/**
 * 设置图片高度，转换URL为oss的URL
 * @param origin
 * @returns
 */
async function normalize(origin: ImageItem, baseName?: string, internal?: boolean): Promise<ImageItem> {
  if (origin.src.length <= 0) {
    return { ...origin };
  }

  const src = media.getOssURL(origin.src, baseName, internal);
  const thumbnail = origin.thumbnail != null ? media.getOssURL(origin.thumbnail, baseName, internal) : undefined;
  const image = { ...origin, src, thumbnail };
  if (origin.width == null && origin.type !== 'video') {
    try {
      const size = await media.getImageSize(src, true);
      return { ...image, ...size };
    } catch {
      const fallbackSrc = internal === true ? undefined : await getHeicFallback(src);
      if (fallbackSrc != null) {
        try {
          const size = await media.getImageSize(fallbackSrc, true);
          return { ...image, ...size, src: fallbackSrc };
        } catch {
          return image;
        }
      }
    }
  }

  return image;
}
